module.exports = __webpack_public_path__ + "img/visa-qr 4.97b3aed9.png";